export const documentTabs = () => {
  const documentTabs = document.querySelectorAll('.document-tabs');

  if (documentTabs) {
    documentTabs.forEach((section) => {
      const panels = section.querySelectorAll('.document-tabs__panel');

      panels.forEach((panel) => {
        const loadButton = panel.querySelectorAll('.document-tabs__panel__cta');

        loadButton.forEach((button) => {
          button.addEventListener('click', () => {
            const hiddenDiv = panel.querySelectorAll(
              '.document-downloads.hidden'
            );
            hiddenDiv.forEach((div) => {
              div.classList.remove('hidden');
              button.remove();
            });
          });
        });
      });
    });
  }
};
